import { create } from 'zustand';

const useAuthStore = create((set, get) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  theme: null,

  login: async (email, password) => {
    try {
      console.log('Login attempt:', { email });
      // Mock authentication using localStorage
      const users = JSON.parse(localStorage.getItem('users') || '[]');
      console.log('Existing users:', users);
      const user = users.find(u => u.email === email && u.password === password);
      console.log('Found user:', user);

      if (user) {
        const token = btoa(JSON.stringify({ email, timestamp: Date.now() }));
        set({
          user: { name: user.name, email: user.email, stream: user.stream },
          isAuthenticated: true,
          isLoading: false,
          theme: user.stream.startsWith('ICSE') ? 'icse' : 'isc',
        });
        localStorage.setItem('token', token);
        localStorage.setItem('currentUser', JSON.stringify(user));
        console.log('Login successful');
        return { success: true };
      }

      console.log('Login failed: Invalid credentials');
      return { success: false, error: 'Invalid email or password' };
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: 'Login failed' };
    }
  },

  signup: async (name, email, password, stream) => {
    try {
      // Mock signup using localStorage
      const users = JSON.parse(localStorage.getItem('users') || '[]');
      
      if (users.find(u => u.email === email)) {
        return { success: false, error: 'Email already registered' };
      }

      const newUser = { name, email, password, stream };
      users.push(newUser);
      localStorage.setItem('users', JSON.stringify(users));

      const token = btoa(JSON.stringify({ email, timestamp: Date.now() }));
      set({
        user: { name, email, stream },
        isAuthenticated: true,
        isLoading: false,
        theme: stream.startsWith('ICSE') ? 'icse' : 'isc',
      });
      localStorage.setItem('token', token);
      localStorage.setItem('currentUser', JSON.stringify(newUser));
      return { success: true };
    } catch (error) {
      return { success: false, error: 'Signup failed' };
    }
  },

  logout: () => {
    set({
      user: null,
      isAuthenticated: false,
      isLoading: false,
      theme: null,
    });
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
  },

  updateProfile: async (name, stream) => {
    try {
      const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
      const users = JSON.parse(localStorage.getItem('users') || '[]');
      
      // Update user in users array
      const userIndex = users.findIndex(u => u.email === currentUser.email);
      if (userIndex !== -1) {
        users[userIndex].name = name;
        users[userIndex].stream = stream;
        localStorage.setItem('users', JSON.stringify(users));
      }

      // Update current user
      const updatedUser = { ...currentUser, name, stream };
      localStorage.setItem('currentUser', JSON.stringify(updatedUser));

      // Update state
      set({
        user: { name, email: currentUser.email, stream },
        theme: stream.startsWith('ICSE') ? 'icse' : 'isc',
      });

      return { success: true };
    } catch (error) {
      console.error('Update profile error:', error);
      return { success: false, error: 'Failed to update profile' };
    }
  },

  checkAuth: async () => {
    const token = localStorage.getItem('token');
    const currentUser = localStorage.getItem('currentUser');
    
    if (!token || !currentUser) {
      set({ isLoading: false });
      return;
    }

    try {
      const user = JSON.parse(currentUser);
      set({
        user: { name: user.name, email: user.email, stream: user.stream },
        isAuthenticated: true,
        isLoading: false,
        theme: user.stream.startsWith('ICSE') ? 'icse' : 'isc',
      });
    } catch (error) {
      set({ isLoading: false });
    }
  },
}));

export default useAuthStore;
